export default __webpack_public_path__ + "static/media/feder.3a076ad5.png";